module.exports = __webpack_public_path__ + "static/media/statement.f79ab1d6.jpg";